import slugify from 'slugify';

interface BuildPageUrlParams {
  domain?: string;
  reverseProxyPath?: string;
  brandName?: string;
  slug?: string;
}

export const buildPageUrl = ({ brandName, domain, reverseProxyPath, slug }: BuildPageUrlParams): string => {
  if (!domain) return '';
  const cleanDomain = domain.replace(/^https?:\/\//, '').replace(/\/$/, '');
  const segments: string[] = [];
  if (reverseProxyPath) {
    segments.push(reverseProxyPath.replace(/^\//, '').replace(/\/$/, ''));
  }
  segments.push('similar');
  segments.push('v2');
  if (brandName) segments.push(slugify(brandName, { strict: true }));
  if (slug) segments.push(slug);
  return `https://${cleanDomain}/${segments.join('/')}`;
};
